import React, { Component } from 'react'
import { StaticBox, LinkedInput } from 'components/basic'

class AccessEditor extends Component {
  constructor (props) {
    super(props)
    this.state = {
      access: null
    }
  }
  componentDidMount () {
    this.setAccess(this.props.access)
  }
  componentWillReceiveProps (props) {
    if (props.access === this.props.access) return
    this.setAccess(props.access)
  }
  setAccess (access) {
    this.setState({access})
  }
  render () {
    if (!this.state.access) return false
    return (
      <StaticBox cols={12} icon='home' title={`${this.state.access.streetName} ${this.state.access.streetNumber}${this.state.access.streetLittera ? this.state.access.streetLittera : ''}`}>
        <div className='row'>
          <div className='col-md-3'>
            <label>Access ID</label>
            <LinkedInput context={this} editable={false} path='access.accessId' />
          </div>
          <div className='col-md-3'>
            <label>Address</label>
            <input className='form-control' disabled value={this.state.access.streetName + ' ' + this.state.access.streetNumber + (this.state.access.streetLittera ? this.state.access.streetLittera : '')} />
          </div>
          <div className='col-md-3'>
            <label>Zipcode</label>
            <LinkedInput context={this} editable={false} path='access.postalCode' />
          </div>
          <div className='col-md-3'>
            <label>City</label>
            <LinkedInput context={this} editable={false} path='access.city' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>Apartment Number</label>
            <LinkedInput context={this} editable={false} path='access.mduApartmentNumber' />
          </div>
          <div className='col-md-3'>
            <label>Apartment Address</label>
            <LinkedInput context={this} editable={false} path='access.mduDistinguisher' />
          </div>
          <div className='col-md-3'>
            <label>Population</label>
            <LinkedInput context={this} editable={false} path='access.population' />
          </div>
          <div className='col-md-3'>
            <label>Premises Type</label>
            <LinkedInput context={this} editable={false} path='access.premisesType' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>CPE Router</label>
            <LinkedInput context={this} editable={false} path='access.coCpeRouter' />
          </div>
          <div className='col-md-3'>
            <label>CPE Switch</label>
            <LinkedInput context={this} editable={false} path='access.coCpeSwitch' />
          </div>
          <div className='col-md-3'>
            <label>Fiber Converter</label>
            <LinkedInput context={this} editable={false} path='access.coFiberConverter' />
          </div>
          <div className='col-md-3'>
            <label>Network Agreement</label>
            <LinkedInput context={this} editable={false} path='access.coNetworkAgreement' />
          </div>
        </div>
        <div className='row'>
          <div className='col-md-3'>
            <label>Outlet</label>
            <LinkedInput context={this} editable={false} path='access.outlet' />
          </div>
          <div className='col-md-3'>
            <label>MDU Apartment Number</label>
            <LinkedInput context={this} editable={false} path='access.mduApartmentNumber' />
          </div>
          <div className='col-md-3'>
            <label>MDU Distinguisher</label>
            <LinkedInput context={this} editable={false} path='access.mduDistinguisher' />
          </div>
          <div className='col-md-3'>
            <label>Access State</label>
            <LinkedInput context={this} editable={false} path='access.accessState' />
          </div>
        </div>
      </StaticBox>
    )
  }
}

export default AccessEditor



// WEBPACK FOOTER //
// ./src/projects/access-gui/components/access/AccessEditor.js